export var RwcActions;
(function (RwcActions) {
    RwcActions["ADD"] = "ADD";
    RwcActions["EDIT"] = "EDIT";
    RwcActions["DELETE"] = "DELETE";
    RwcActions["ACTIVATE"] = "ACTIVATE";
    RwcActions["DEACTIVATE"] = "DEACTIVATE";
})(RwcActions || (RwcActions = {}));
export var IdwEntities;
(function (IdwEntities) {
    IdwEntities["IDW"] = "IDW";
    IdwEntities["Skill"] = "Skill";
    IdwEntities["Flow"] = "Flow";
    IdwEntities["Tag"] = "Tag";
    IdwEntities["Channel"] = "Channel";
    IdwEntities["Domain"] = "Domain";
    IdwEntities["Memory"] = "Memory";
})(IdwEntities || (IdwEntities = {}));
//# sourceMappingURL=rwcPayload.js.map